import { Component } from '@angular/core'
import { ProductsClient } from 'src/app/shared/services/ppv.api'

import Feedback from '@betahuhn/feedback-js'
import { FeedbackService } from 'src/app/shared/services/feedback'

@Component({
   selector: 'vc-products-feedback',
   templateUrl: './products-feedback.component.html',
   styleUrls: ['./products-feedback.component.scss'],
   standalone: false,
})
export class ProductsFeedbackComponent {
   feedback = undefined

   constructor(private api: ProductsClient, private fb: FeedbackService) {
      /*this.fb.onProductFeedback.subscribe((event: any) => {
      console.log(event);
      this.api
        .feedback({
          feedbackType: event.detail.feedbackType,
          message: event.detail.message,
          url: event.detail.url,
        })
        .subscribe();
    });*/
   }

   onFeedback() {
      this.fb.showProductFeedbackModal()
   }
}
